export const SET_OFFLINE_REVIEWS_COUNT = 'SET_OFFLINE_REVIEWS_COUNT'
